<template>
  <!-- 试用期评估申请 -->
  <div>
    <Collapse v-model="value" simple style="border:0" :disabled="prevent">
      <Panel name="1" hide-arrow style="margin-bottom: 20px;border:0">
        <FormTitle :titleText="$t('基本信息')" style="margin-bottom: 30px" />
        <Form
          slot="content"
          :label-width="150"
          label-position="left"
          :disabled="prevent"
          style="margin: 30px 30px 0 30px"
        >
          <Row class="rowAllBox" type="flex" justify="space-between">
            <Col span="7" :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem :label="$t('员工工号')">
                <Input v-model="formItem.serialnumber" :disabled="isHistory">
                  <Button
                    slot="append"
                    icon="ios-search"
                    :disabled="isHistory"
                    @click="select"
                  ></Button>
                </Input>
              </FormItem>
            </Col>
            <Col span="7" :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem :label="$t('员工姓名')">
                <Input v-model="formItem.userName" :disabled="true" />
              </FormItem>
            </Col>
            <Col span="7" :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem :label="$t('职位名称')">
                <Input v-model="formItem.positionName" :disabled="true" />
              </FormItem>
            </Col>
          </Row>
          <!-- <Row class="rowAllBox" type="flex" justify="space-between">
            <Col span="7" :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem :label="$t('公司')">
                <Input disabled v-model="formItem.orgsname2" />
              </FormItem>
            </Col>
            <Col span="7" :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem :label="$t('地区')">
                <Input disabled v-model="formItem.orgsname4" />
              </FormItem>
            </Col>
            <Col span="7" :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem :label="$t('部门')">
                <Input disabled v-model="formItem.orgsname5" />
              </FormItem>
            </Col>
          </Row> -->
          <Row class="rowAllBox" type="flex" justify="space-between">
            <Col span="7" :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem :label="$t('试用期结束日 ')">
                <Date-picker
                  v-model="formItem.probationenddate"
                  disabled
                  type="date"
                  placeholder=""
                  style="width: 100%;"
                ></Date-picker>
              </FormItem>
            </Col>
          </Row>
        </Form>
      </Panel>
      <Panel name="2" hide-arrow style="margin-bottom: 20px;border:0">
        <FormTitle :titleText="$t('评估决定')" style="margin-bottom: 30px" />
        <Form
          slot="content"
          :label-width="150"
          label-position="left"
          :disabled="prevent"
          style="margin: 30px 30px 0 30px"
        >
          <Row class="rowAllBox" type="flex" justify="space-between">
            <Col span="7" :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem :label="$t('评估编码')">
                <Input v-model="formItem.reviewCode" :disabled="isHistory" />
              </FormItem>
            </Col>
            <Col span="7" :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem :label="$t('中文描述')">
                <Input v-model="formItem.reviewCname" :disabled="isHistory" />
              </FormItem>
            </Col>
            <Col span="7" :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem :label="$t('英文描述')">
                <Input v-model="formItem.reviewEname" :disabled="isHistory" />
              </FormItem>
            </Col>
          </Row>
          <Row class="rowAllBox" type="flex" justify="space-between">
            <Col span="7" :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem :label="$t('开始日期')">
                <Date-picker
                  type="date"
                  style="width: 100%"
                  v-model="formItem.beginDate"
                  :disabled="isHistory"
                ></Date-picker>
              </FormItem>
            </Col>
            <Col span="7" :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem :label="$t('结束日期')">
                <Date-picker
                  type="date"
                  style="width: 100%"
                  v-model="formItem.endDate"
                  :disabled="isHistory"
                ></Date-picker>
              </FormItem>
            </Col>
            <Col span="7" :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem :label="$t('评估日期')">
                <Date-picker
                  type="date"
                  style="width: 100%"
                  v-model="formItem.reviewDate"
                  :disabled="isHistory"
                ></Date-picker>
              </FormItem>
            </Col>
          </Row>
          <Row class="rowAllBox" type="flex" justify="space-between">
            <Col span="7" :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem :label="$t('评估类型')">
                <Select
                  v-model="formItem.reviewType"
                  :clearable="true"
                  :disabled="isHistory"
                  placeholder=""
                >
                  <Option
                    :value="item.code"
                    v-for="(item, i) in reviewTypeList"
                    :key="i"
                    >{{ item.name }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
          </Row>
          <Row class="rowAllBox" type="flex" justify="space-between">
            <Col span="14" :xs="24" :sm="24" :md="24" :lg="24">
              <FormItem span="3" :label="$t('备注')">
                <Input
                  type="textarea"
                  v-model="formItem.comment"
                  :disabled="isHistory"
                />
              </FormItem>
            </Col>
          </Row>
        </Form>
      </Panel>
      <Row class="btnRight">
        <Col>
          <Button class="applyBtnRight" v-if="!isHistory" @click="importCG"
            >导入草稿</Button
          >
          <Button class="applyBtnRight" v-if="!isHistory" @click="saveCG"
            >保存草稿</Button
          >
          <Button class="applyBtnRight" v-if="!isHistory" @click="dataSubmit"
            >提交</Button
          >
          <Button class="applyBtnRight" @click="returnPage">返回</Button>
        </Col>
      </Row>
      <Panel
        name="4"
        hide-arrow
        style="margin-bottom: 20px;border:0"
        v-if="isHistory"
      >
        <FormTitle :titleText="$t('审批履历')" />
        <Table
          border
          :columns="lvLiMessage"
          :data="data2"
          slot="content"
          style="margin: 30px 30px 0 30px"
        ></Table>
      </Panel>
    </Collapse>
    <Spin size="large" fix v-if="spinShow"></Spin>
    <!-- 草稿模板列表 -->
    <j2-DraftTemplate ref="cgTem" @getCGDa="getCGDa1" />
    <j2-DraftPop ref="cgPop" />
    <!-- 弹框 选择员工 -->
    <Modal v-model="empoloyee" :title="$t('选择员工')" width="900px">
      <Form :model="filter" inline :label-width="50" label-position="left">
        <FormItem :label="$t('员工工号') + '：'" :label-width="120">
          <Input
            type="text"
            v-model="filter.serialnumber"
            placeholder="请输入员工工号"
            style="width: 140px"
          ></Input>
        </FormItem>
        <FormItem :label="$t('员工姓名') + '：'" :label-width="120">
          <Input
            type="text"
            v-model="filter.userName"
            placeholder="请输入员工姓名"
            style="width: 150px"
          ></Input>
        </FormItem>
        <Button
          type="primary"
          @click="(total = 0), (pageInfo.pageNo = 1), getp()"
          >{{ $t("Search") }}</Button
        >
      </Form>
      <Table
        border
        ref="myTable"
        :loading="prevent"
        :columns="columns1"
        :data="data1"
      >
        <template slot-scope="{ row, index }" slot="action">
          <Button
            type="primary"
            size="small"
            style="margin-right: 5px"
            @click="select1(row, index)"
            >{{ $t("选择") }}</Button
          >
        </template>
      </Table>
      <Page
        style="margin-top: 20px; text-align: right"
        :total="total"
        @on-change="pageChange"
      />
      <div slot="footer">
        <Button type="text" @click="handleCancle">{{ $t("取消") }}</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import axios from "axios";
import DateUtil from "../../../util/DateUtil";
export default {
  data() {
    return {
      date: new DateUtil(),
      value: [1, 2, 4],
      //  resourceId_List: [],
      pageInfo: {
        itemCount: 0,
        pageNo: 1,
        pageSize: 10
      },
      total: 0,
      formItem: {
        department: "",
        onboarding_date: null,
        business_title: "",
        employee_name: ""
      },
      empoloyee: false,
      filter: {},
      prevent: false,
      data1: [],
      reviewTypeList: [],
      data2: [],
      isHistory: false,
      spinShow: false
    };
  },
  computed: {
    columns1() {
      return [
        {
          title: this.$t("操作"),
          slot: "action",
          align: "center",
          width: "150"
        },
        {
          title: this.$t("员工工号"),
          key: "serialnumber",
          align: "center"
        },
        {
          title: this.$t("员工姓名"),
          key: "userName",
          align: "center"
        },
        {
          title: this.$t("试用期结束日"),
          key: "probationenddate",
          align: "center",
          render: (h, params) => {
            return h(
              "span",
              this.date.dateVal(params.row.probationenddate, "YYYY-MM-DD")
            );
          }
        },
        {
          title: "职位名称",
          key: "positionName",
          align: "center"
        }
      ];
    },
    lvLiMessage() {
      return [
        {
          title: this.$t("审批流名称"),
          key: "stepName",
          align: "center",
          width: "280"
        },
        {
          title: this.$t("实际审批者"),
          key: "userName",
          align: "center",
          width: "280"
        },
        {
          title: this.$t("审批时间"),
          key: "time",
          align: "center",
          width: "280",
          render: (h, params) => {
            return h(
              "span",
              this.date.dateVal(params.row.time, "YYYY-MM-DD HH:mm")
            );
          }
        },
        {
          title: this.$t("审批状态"),
          key: "status",
          align: "center",
          width: "280",
          render: (h, params) => {
            return h(
              "span",
              params.row.status == "0"
                ? "通过"
                : params.row.status == "1"
                ? "驳回"
                : ""
            );
          }
        },
        {
          title: this.$t("审批意见"),
          key: "message",
          align: "center",
          width: "465"
        }
      ];
    }
  },
  created() {
    if (this.getQueryVariable("history")) {
      this.isHistory = true;
    }
  },
  mounted() {
    if (this.isHistory) {
      this.initData();
    }
  },
  methods: {
    //打开草稿列表
    importCG() {
      this.$refs.cgTem.getInternation();
      //草稿type 操作人
      this.$refs.cgTem.popShow(
        "PR01",
        JSON.parse(sessionStorage.getItem("userInfo")).userId
      );
    },
    //保存草稿
    saveCG() {
      this.$refs.cgPop.getInternation();
      //草稿type 草稿内容
      // this.formItem.attachment_name = this.$refs.file.fileName
      this.formItem.probationenddate
        ? (this.formItem.probationenddate = this.date.dateVal(
            this.formItem.probationenddate,
            "YYYY-MM-DD"
          ))
        : "";
      this.formItem.beginDate
        ? (this.formItem.beginDate = this.date.dateVal(
            this.formItem.beginDate,
            "YYYY-MM-DD"
          ))
        : "";
      this.formItem.endDate
        ? (this.formItem.endDate = this.date.dateVal(
            this.formItem.endDate,
            "YYYY-MM-DD"
          ))
        : "";
      this.formItem.reviewDate
        ? (this.formItem.reviewDate = this.date.dateVal(
            this.formItem.reviewDate,
            "YYYY-MM-DD"
          ))
        : "";
      this.$refs.cgPop.popShow("PR01", { formItem: this.formItem });
    },
    //导入草稿数据到页面
    getCGDa1(row) {
      this.getp();
      var obj = JSON.parse(row.draftContent);
      this.formItem = obj.formItem;
    },
    pageChange(val) {
      this.pageInfo.pageNo = val;
      this.getp(this.pageInfo.pageNo);
    },
    initData() {
      if (this.isHistory) {
        let arr = {
          instanceId: this.getQueryVariable("instanceId")
        };
        axios.post("/probation/searchProbationInfo", arr).then(res => {
          if (res) {
            this.formItem = res.basicInfo;
            this.reviewTypeList = res.optionList;
            this.formItem.userName = res.basicInfo.applyName;
            this.formItem.serialnumber = res.basicInfo.applySerialnumber;
            this.formItem.positionName = res.basicInfo.applyPositionName;
            this.formItem.probationenddate = res.basicInfo.endProbationPeriod;
            this.formItem.comment = res.basicInfo.comments;
            this.data2 = res.logMap;
          }
        });
      }
    },
    select() {
      this.empoloyee = true;
    },
    select1(row, index) {
      this.selectone(row);
      this.empoloyee = false;
    },
    selectone(row) {
      this.formItem = row;
    },
    handleCancle() {
      this.empoloyee = false;
    },
    getp() {
      let arr = {
        serialnumber: this.filter.serialnumber,
        userName: this.filter.userName,
        pageNum: this.pageInfo.pageNum,
        pageSize: this.pageInfo.pageSize,
        optionName: ["REVIEWTYPE"]
      };
      this.prevent = true;
      axios.post("/probation/searchProbationUser", arr).then(res => {
        this.prevent = false;
        if (res) {
          this.data1 = res.data;
          this.reviewTypeList = res.optionData.REVIEWTYPE;
        }
      });
    },
    dataSubmit() {
      this.$Modal.confirm({
        title: this.$notice("submission"),
        content: "",
        onOk: () => {
          this.prevent = true;
          this.handle();
        },
        onCancel: () => {}
      });
    },
    handle() {
      let arr = [
        {
          objData1: {
            ...this.formItem,
            apply_serialnumber: this.formItem.serialnumber,
            apply_user_id: this.formItem.empCode,
            apply_name: this.formItem.userName,
            apply_position_name: this.formItem.positionName,
            apply_position: this.formItem.positionId,
            comments: this.formItem.comment,
            end_probation_period: this.date.dateVal(
              this.formItem.probationenddate,
              "YYYY-MM-DD"
            ),
            begin_date: this.date.dateVal(
              this.formItem.beginDate,
              "YYYY-MM-DD"
            ),
            end_date: this.date.dateVal(this.formItem.endDate, "YYYY-MM-DD"),
            review_date: this.date.dateVal(
              this.formItem.reviewDate,
              "YYYY-MM-DD"
            ),
            review_code: this.formItem.reviewCode,
            review_cname: this.formItem.reviewCname,
            review_ename: this.formItem.reviewEname,
            review_type: this.formItem.reviewType,
            review_person: this.formItem.reviewPerson,
            appr_person: this.formItem.apprPerson,

            agent_apply_user_id: JSON.parse(
              window.sessionStorage.getItem("userInfo")
            ).userId,
            agent_apply_serialnumber: JSON.parse(
              window.sessionStorage.getItem("userInfo")
            ).serialnumber,
            agent_apply_name: JSON.parse(
              window.sessionStorage.getItem("userInfo")
            ).userName,
            agent_apply_position: this.formItem.positionId,
            agent_apply_position_name: this.formItem.positionName,
            be_agent: 0
          },
          stringData1: "PR01",
          stringData4: this.formItem.empCode,
          stringData10: this.formItem.reviewCode,
          type: "B31"
        }
      ];
      this.spinShow = true;
      axios.post("/process/execute", arr).then(res => {
        this.spinShow = false;
        if (res) {
          this.$Message.info(this.$t("sbumit_Success"));
          this.$router.push(
            "/479EB7C68FD1C711E1668077E8206CA1/A3FFBEBFDB713E27"
          );
        }
      });
    },
    getQueryVariable(variable) {
      var query = window.location.search.substring(1);
      var vars = query.split("&");
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
          return pair[1];
        }
      }
      return false;
    },
    returnPage() {
      if (this.isHistory) {
        this.$router.push("/EE8D3DF28FEFA1026138E1506FB19594/A3FFBEBFDB713E27");
      } else {
        this.$router.go(-1);
      }
    }
  }
};
</script>

<style scoped>
.ivu-input-search {
  cursor: pointer;
  padding: 0 16px !important;
  color: #000 !important;
  background: #f8f8f9 !important;
  border-color: #dcdee2 !important;
  transition: all 0.2s ease-in-out;
  position: relative;
  z-index: 2;
}
</style>



// WEBPACK FOOTER //
// src/components/process/Apply/ProbationApply.vue